import React, { Component } from "react";
import api from "../../../services/api";
import MaskedField from "../../../components/MaskedField";
import cpfMask from "../../../components/Masks/Cpf";
import * as Yup from "yup";
import { Button, Modal, Col, Row, Icon, notification } from "antd";
import { Input, Form, Select } from "@rocketseat/unform";

import "./styles.css";

export default class PastaForm extends React.Component {
  state = {
    loading: false,
    cooperado_mask: cpfMask(""),
    form_inputs: document.getElementsByClassName("ant-input")
  };

  schema = {
    pasta: Yup.string().required("Campo obrigatório"),
    singular: Yup.string().required("Campo obrigatório"),
    cpf_cnpj: Yup.string().required("Campo obrigatório"),
    cooperado: Yup.string().required("Campo obrigatório"),
    agencia: Yup.string().required("Campo obrigatório"),
    email: Yup.string().required("Campo obrigatório"),
    conta: Yup.string().required("Campo obrigatório"),
    telefone: Yup.string().required("Campo obrigatório"),
    endereco: Yup.string().required("Campo obrigatório")
  };

  /** Dados iniciais no formulário */

  yup_schema = Yup.object().shape(this.schema);

  handleSubmit = async data => {
    this.setState({
      loading: true
    });

    await api
      .put("/pasta/pastas/" + this.props.pasta.pasta + "/", data)
      .then(response => {
        console.log("SUCESSO");
        notification.success({
          message: "Pasta editada com sucesso!"
        });
        setTimeout(() => {
          location.reload();
        }, 1000);
      })
      .catch(error => {
        console.error(error);

        notification.error({
          message: "Erro ao editar pasta"
        });

        this.setState({
          loading: false
        });
      });
  };

  render() {
    const onDocumentChange = event => {
      this.setState({
        cooperado_mask: cpfMask(event.target.value)
      });
    };

    return (
      <div className="cad_sancor">
        <Form
          onSubmit={this.handleSubmit}
          schema={this.yup_schema}
          initialData={this.props.pasta}
        >
          <Row gutter={24}>
            <Col sm={{ span: 12 }}>
              <div className="d-flex cad_sancor__input">
                <label>Pasta:</label>
                <div className="editar_pasta__input">
                  <Input type="text" name="pasta" className="ant-input" />
                </div>
              </div>
              <div className="d-flex cad_sancor__input">
                <label>Instituição:</label>
                <div className="editar_pasta__input">
                  <Select
                    name="singular"
                    className="ant-input"
                    options={[
                      { id: -1, title: "Selecione" },
                      { id: "OURO VERDE", title: "OURO VERDE" },
                      { id: "COOPMIL", title: "COOPMIL" },
                      { id: "BRADESCO-PR", title: "BRADESCO-PR" },
                      { id: "BRADESCO-SC", title: "BRADESCO-SC" },
                      { id: "BRADESCO-OUTROS", title: "BRADESCO-OUTROS" },
                      { id: "SISPRIME", title: "SISPRIME" },
                      { id: "ORALSIN", title: "ORALSIN" },
                      { id: "ESPE", title: "ESPE" },
                      { id: "ESPD", title: "ESPD" },
                      { id: "ARACOOP", title: "ARACOOP" }
                    ]}
                  />
                </div>
              </div>
              <div className="d-flex cad_sancor__input">
                <label>Agencia:</label>
                <div className="editar_pasta__input">
                  <Input type="text" name="agencia" className="ant-input" />
                </div>
              </div>
              <div className="d-flex cad_sancor__input">
                <label>Conta:</label>
                <div className="editar_pasta__input">
                  <Input type="text" name="conta" className="ant-input" />
                </div>
              </div>
            </Col>
            <Col sm={{ span: 12 }}>
              <div className="d-flex cad_sancor__input">
                <label>Devedor:</label>
                <div className="editar_pasta__input">
                  <Input type="text" name="cooperado" className="ant-input" />
                </div>
              </div>
              <div className="d-flex cad_sancor__input">
                <label>CPF/CNPJ:</label>
                <div className="editar_pasta__input">
                  <MaskedField
                    name="cpf_cnpj"
                    className="ant-input"
                    mask={this.state.cooperado_mask}
                    type="text"
                    customfunction={onDocumentChange}
                  />
                </div>
              </div>
              <div className="d-flex cad_sancor__input">
                <label>Endereco:</label>
                <div className="editar_pasta__input">
                  <Input type="text" name="endereco" className="ant-input" />
                </div>
              </div>
              <div className="d-flex cad_sancor__input">
                <label>Email:</label>
                <div className="editar_pasta__input">
                  <Input type="text" name="email" className="ant-input" />
                </div>
              </div>
              <div className="d-flex cad_sancor__input">
                <label>Telefone:</label>
                <div className="editar_pasta__input">
                  <Input type="text" name="telefone" className="ant-input" />
                </div>
              </div>
            </Col>
          </Row>
          <div
            className="d-flex"
            style={{ justifyContent: "flex-end", margin: "10px" }}
          >
            {/** Botão de submit */}
            <Button
              htmlType="submit"
              type="primary"
              loading={this.state.loading}
            >
              {this.state.loading ? null : <Icon type="save" />} Salvar
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Pasta/components/index.js